import React, { forwardRef } from "react";
import { twMerge } from "tailwind-merge";

import { array, bool, string } from "prop-types";

const SelectField = forwardRef(function SelectField(props, ref) {
  const {
    className,
    defaultValue,
    disabled,
    fullWidth = false,
    label,
    options,
    required,
    ...restProps
  } = props;

  return (
    <label
      className={twMerge(
        "block mt-4 cursor-text",
        fullWidth && "w-full",
        className
      )}
    >
      {label}
      {required && "*"}
      <div
        className={twMerge(
          "flex items-center mt-2 border-2 border-greyLight rounded-sm text-base tracking-wide",
          disabled ? "bg-greyLight pointer-events-none" : "bg-white"
        )}
      >
        <select
          className="p-2 bg-transparent border-0 outline-none flex-1-1-0"
          disabled={disabled}
          ref={ref}
          required={required}
          value={defaultValue}
          {...restProps}
        >
          {options.map(option => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </select>
      </div>
    </label>
  );
});

SelectField.propTypes = {
  options: array.isRequired,
  className: string,
  disabled: bool,
  defaultValue: string,
  fullWidth: bool,
  label: string,
  required: bool,
  selectedValue: string,
};

export default SelectField;
